// material-ui
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

// project imports
import AnimateButton from "ui-component/extended/AnimateButton";
import { useEffect, useState } from "react";
import { set } from "lodash";

// styles
const CardStyle = styled(Card)(({ theme }) => ({
  background:
    theme.palette.mode === "dark"
      ? theme.palette.dark[800]
      : theme.palette.warning.light,
  marginTop: "16px",
  marginBottom: "16px",
  overflow: "hidden",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    width: "200px",
    height: "200px",
    border: "19px solid ",
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.warning.main
        : theme.palette.warning.main,
    borderRadius: "50%",
    top: "65px",
    right: "-150px",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "200px",
    height: "200px",
    border: "3px solid ",
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.warning.main
        : theme.palette.warning.main,
    borderRadius: "50%",
    top: "145px",
    right: "-70px",
  },
}));

// ==============================|| PROFILE MENU - UPGRADE PLAN CARD ||============================== //

const UpgradePlanCard = () => {
  const theme = useTheme();
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState<boolean>(false);
  const [loginCredentialsData, setLoginCredentialsData] = useState<any>({});

  const isAdmin = () => {
    const loginCredentialsString = localStorage.getItem("login-credentials");

    if (loginCredentialsString) {
      let loginCredentials = JSON.parse(loginCredentialsString);
      if (loginCredentials.name === "admin") {
        setIsAdminLoggedIn(loginCredentials.name === "admin");
      } else {
        setIsAdminLoggedIn(false);
      }
      setLoginCredentialsData(loginCredentials);
    }
  };

  useEffect(() => {
    isAdmin();
  }, []);

  return (
    <CardContent>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Typography variant="h4">
            Hello,{" "}
            {isAdminLoggedIn
              ? `Admin`
              : `${loginCredentialsData.firstName} ${loginCredentialsData.lastName}`}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant="h5"
            color={theme.palette.mode === "dark" ? "textSecondary" : "grey.900"}
            sx={{ opacity: theme.palette.mode === "dark" ? 1 : 0.6 }}
          >
            Email ID: {loginCredentialsData.email}
          </Typography>
          {!isAdminLoggedIn && (
            <Typography
              variant="h5"
              color={
                theme.palette.mode === "dark" ? "textSecondary" : "grey.900"
              }
              sx={{ opacity: theme.palette.mode === "dark" ? 1 : 0.6, mb: 0.5 }}
            >
              Project ID: {loginCredentialsData.projectCode}
            </Typography>
          )}
        </Grid>
      </Grid>
    </CardContent>
  );
};

export default UpgradePlanCard;
